import React from "react";

const Section2 = ({ url }) => {

  const cards = [
    {
      title: "AI Built on Hype Delivers Hype-Level Results",
      desc: "Most AI implementations are a ChatGPT wrapper with a company logo on it. They do not integrate with your systems, they do not learn from your data, and they do not solve the actual problem they were brought in to fix. Real AI development starts with understanding your operations, not with choosing a model.",
    },
    {
      title: "Your Team Is Still Doing What Automation Was Supposed to Handle",
      desc: "Manual data entry, repetitive approval workflows, report generation, customer query routing. These are not problems your team should still own in 2025. Every hour your team spends on a task that can be automated is an hour they are not spending on work that actually requires human judgment.",
    },
    {
      title: "Off-the-Shelf AI Tools Create Fragmented Stacks, Not Solutions",
      desc: "Plugging in five SaaS AI tools does not create an intelligent operation. It creates five more disconnected data sources, five more subscriptions, and five more failure points. Custom AI development builds intelligence into your existing infrastructure rather than around it.",
    },
  ];

  return (
    <section className="home-section-2">
      <div className="container overflow-hidden">

        <h2 className="s2-title" data-aos="fade-up">
          Why Most AI Projects Fail to <br />Deliver Business Value
        </h2>

        <p className="s2-subtitle" data-aos="fade-up" data-aos-delay="100">
          The problem is not that AI does not work. The problem is that most AI projects are built as demonstrations, not solutions. They impress in a boardroom and stall in production. If your business has explored AI and walked away underwhelmed, you are not alone, and you are probably not wrong to be skeptical.
        </p>

        <div className="s2-cards-row" data-aos="fade-up" data-aos-delay="200">
          {cards.map((card, idx) => (
            <div className="s2-card" key={idx}>
              <h3 className="s2-card-title">{card.title}</h3>
              <p className="s2-card-desc">{card.desc}</p>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default Section2;